<template>
  <svg
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.86393 4.46978L3.68569 1.35175C3.48857 1.15837 3.48857 0.844826 3.68569 0.65144C3.88281 0.458055 4.20241 0.458055 4.39953 0.65144L7.92833 4.11339C8.03301 4.21609 8.0821 4.35267 8.0756 4.48716C8.0729 4.6103 8.02366 4.73264 7.92788 4.82661L4.39907 8.28855C4.20195 8.48194 3.88236 8.48194 3.68524 8.28855C3.48812 8.09517 3.48812 7.78163 3.68524 7.58824L6.86393 4.46978Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.32877 4.46977L0.150534 1.35175C-0.0465863 1.15837 -0.0465863 0.844826 0.150534 0.65144C0.347655 0.458054 0.66725 0.458054 0.864371 0.65144L4.39317 4.11339C4.49786 4.21609 4.54695 4.35267 4.54044 4.48715C4.53775 4.6103 4.48851 4.73264 4.39272 4.82661L0.863917 8.28855C0.666796 8.48194 0.347201 8.48194 0.15008 8.28855C-0.04704 8.09517 -0.0470404 7.78163 0.150081 7.58824L3.32877 4.46977Z"
      fill="white"
      fill-opacity="0.55"
    />
  </svg>
</template>
